import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {billingPlatformApi} from 'api';
import {ConfirmModal, DataWrapper} from 'components';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.SUBSCRIPTION.REMOVE_SCHEDULED_PAUSE_MODAL;

type Props = {
    open: boolean;
    onClose: (success: boolean) => void;
}

export const ConfirmRemovePauseModal: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();

    const onRemovePauseSuccess = useCallback(() => {
        onClose(true);
    }, [onClose]);

    const {send: removePauseSubscription, error, loading} = useApiData(billingPlatformApi.removePauseSubscription, {
        onSuccess: onRemovePauseSuccess
    });

    const handleClose = useCallback((confirm: boolean) => {
        if (confirm) {
            removePauseSubscription();
        } else {
            onClose(false);
        }
    }, [removePauseSubscription, onClose]);

    return (
        <ConfirmModal
            open={open}
            maxWidth='xs'
            fullWidth
            title={t(T_KEYS.TITLE)}
            okDisabled={loading}
            onClose={handleClose}
        >
            {/* TODO: design */}
            <DataWrapper isLoading={loading} isError={!!error} hideContentOnLoading={false}>
                <div className='tw-ts-h5'>{t(T_KEYS.MESSAGE)}</div>
            </DataWrapper>
        </ConfirmModal>
    );
};